import { createContext, useContext } from 'react'

import defaultOptions from './src/utils/defaultOptions'

// eslint-disable-next-line import/prefer-default-export
export const themeOptions = createContext(defaultOptions)

export const useThemeOptions = () => useContext(themeOptions)
